export enum AttackErrorAttribute {
  OutAttack = 527,
  AntennaAttack = 528,
  NetAttack = 529,
  Zone1 = 867,
  Zone2 = 868,
  Zone3 = 869,
  Zone4 = 870,
  Zone5 = 871,
  Zone6 = 872,
  IllegalTouch = 873,
}
